import { ReactElement } from "react";
import Tooltip from "@mui/material/Tooltip";

/**
 * CR-DRIVALIA-EPCH (LPP-22837): azione in coda a una chip della testata (es. storico stato, sgancio
 * identita' digitale). Usa onDelete/deleteIcon della Chip MUI: l'icona porta il tooltip e, se
 * disabilitata, resta visibile ma spenta, cosi' il tooltip puo' spiegare perche'.
 */
export const chipActionIcon = (title: string, icon: ReactElement) => (
    <Tooltip title={title}>{icon}</Tooltip>
);

export const chipActionSx = (disabled = false) => ({
    "& .MuiChip-deleteIcon": {
        color: "white",
        fontSize: 18,
        marginLeft: "2px",
        paddingLeft: "6px",
        boxSizing: "content-box",
        borderLeft: "1px solid rgba(255,255,255,0.55)",
        opacity: disabled ? 0.45 : 0.9,
        cursor: disabled ? "not-allowed" : "pointer",
        "&:hover": { color: "white", opacity: disabled ? 0.45 : 1 },
    },
});
